export class MaClient {
  company_id: number | null = null;
  company_name: string | null = null;
  company_type_id: number | null = null;
  email: string | null = null;
  phone_number: number | null = null;
  vsl_ids: number | null = null;
  address: string | null = null;
  status: boolean | string | null;
  constructor(maClient?: Partial<MaClient>) {
    Object.assign(this, maClient);
    this.status = true;
    this.address = maClient?.address ? maClient.address : '';
    this.vsl_ids = maClient?.vsl_ids ? maClient.vsl_ids : null;
    this.phone_number = maClient?.phone_number ? maClient.phone_number : null;
    this.email = maClient?.email ? maClient.email : null;
    this.company_id = maClient?.company_id ? maClient.company_id : null;
    this.company_name = maClient?.company_name ? maClient.company_name : null;
    this.company_type_id = maClient?.company_type_id
      ? maClient.company_type_id
      : null;
    }
  }
